import { ILicense, ISecureService } from "../_types/interfaces";


const getCode = async (): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => resolve(
        "01234-56789-ABCDE-FJHIGK",
    ), 1000));
};

const getServicesCode = async (): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => resolve(
        "FFFFF",
    ), 1000));
};

const getServerAddress = async (): Promise<string> => {
    return new Promise<string>(resolve => setTimeout(() => resolve(
        "http://84.201.169.119:18080",
    ), 1000));
};

const getLicensesForServices = async (): Promise<Array<ILicense>> => {
    return new Promise<Array<ILicense>>(resolve => setTimeout(() => resolve([
        {ServiceName: 'Plugin_R_LocalLoader', ValidUntil: "17-11-2022", Code: "01234-56789-ABCDE-FJHIGK", Signature: "01234-56789-ABCDE-FJHIGK"},
        {ServiceName: 'Reader', ValidUntil: "17-12-2022", Code: "01234-56789-ABCDE-FJHIGK", Signature: "01234-56789-ABCDE-FJHIGK"}
    ]), 1000));
};


export const fakeSecureServices: ISecureService = {
    getCode,
    getServicesCode,
    getServerAddress,
    getLicensesForServices,
};